import { render, staticRenderFns } from "./option-dialog.vue?vue&type=template&id=1edfbf48&scoped=true&"
import script from "./option-dialog.vue?vue&type=script&lang=js&"
export * from "./option-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edfbf48",
  null
  
)

export default component.exports